import React, { memo, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';

import { constants } from '@config';
import { selectors } from '@store';

import { useViewport } from './ViewportProvider';
import VirtualPage from './VirtualPage';
import { LinkedTextElementChains } from './LinkedTextElementChains';

const { pagePaddingInPx } = constants.text;

const Wrapper = styled.div`
  position: relative;
  margin: auto;
  width: fit-content;
`;
function VirtualPages ({ scrollRef }) {
  const { state: { viewportPageWidth = 0 } } = useViewport();

  const pages = useSelector((state) => selectors.editor.getExtendedPages(
    state,
    viewportPageWidth,
    pagePaddingInPx
  ));

  const extendedElements = useSelector((state) => selectors.editor.getExtendedElements(
    state,
    pages
  ));

  const linkedTextElementChains = useSelector(state => selectors.editor.getLinkedTextElementChains(
    state,
    extendedElements
  ));

  const activePageIndex = useSelector(selectors.editor.getActivePageIndex);

  useEffect(() => {
    const top = pages[activePageIndex]?.top;
    if (activePageIndex > 0 && top) {
      scrollRef.current.scrollBy({ top });
    }
  }, []);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  return (
    <Wrapper>
      {pages.map((page) => {
        const elements = extendedElements.filter(({ pageId }) => pageId === page.id);

        return (
          <VirtualPage
            key={'VirtualPage' + page.id}
            page={page}
            elements={elements}
          />
        );
      })}
      <LinkedTextElementChains chains={linkedTextElementChains} />
    </Wrapper>
  );
}

VirtualPages.propTypes = {
  scrollRef: PropTypes.object
};

export default memo(VirtualPages);
